/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/scripts.js":
/*!******************************!*\
  !*** ./resources/scripts.js ***!
  \******************************/
/***/ (() => {

document.addEventListener('DOMContentLoaded', function () {
  console.log('Variant gallery script initialized');
  var fadeDuration = 400;
  function getGallery() {
    return document.querySelector('media-gallery');
  }
  function setGalleryReady(gallery) {
    if (!gallery) return;
    gallery.classList.add('media-gallery--ready');
  }
  function fadeIn(el) {
    if (!el) return;
    el.style.transition = 'none';
    el.style.opacity = '0';
    el.offsetHeight;
    el.style.transition = "opacity ".concat(fadeDuration, "ms ease");
    requestAnimationFrame(function () {
      el.style.opacity = '1';
    });
  }
  function setActiveSlide(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    var thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item'));
    slides.forEach(function (slide) {
      var active = slide.dataset.mediaId === mediaId;
      slide.classList.toggle('is-active', active);
      slide.style.display = active ? '' : 'none';
      slide.style.opacity = active ? '1' : '0';
      if (active) {
        fadeIn(slide);
      }
    });
    thumbs.forEach(function (thumb) {
      var active = thumb.dataset.target === mediaId;
      thumb.classList.toggle('is-active', active);
      var button = thumb.querySelector('button.thumbnail');
      if (button) {
        if (active) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      }
    });
  }
  function showAllImages() {
    var gallery = getGallery();
    if (!gallery) return;
    var slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    var thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item'));
    slides.forEach(function (slide) {
      slide.style.display = '';
      slide.style.opacity = '1';
      slide.classList.remove('is-active');
    });
    thumbs.forEach(function (thumb) {
      thumb.style.display = '';
      thumb.style.opacity = '1';
      thumb.classList.remove('is-active');
      var button = thumb.querySelector('button.thumbnail');
      if (button) {
        button.removeAttribute('aria-current');
      }
    });
    if (slides.length === 1) {
      slides[0].classList.add('is-active');
      slides[0].style.display = '';
      slides[0].style.opacity = '1';
    }
    if (slides.length > 0) {
      setActiveSlide(gallery, slides[0].dataset.mediaId);
    }
    setGalleryReady(gallery);
  }
  function filterVariant(variantName) {
    var gallery = getGallery();
    if (!gallery) return;
    var slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    var thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item'));
    var firstVisible = null;
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var matches = img.alt.trim().toLowerCase().includes(variantName.toLowerCase());
      if (matches && !firstVisible) {
        firstVisible = slide.dataset.mediaId;
      }
      slide.style.display = 'none';
      slide.style.opacity = '0';
      slide.classList.remove('is-active');
    });
    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      if (!img) return;
      var matches = img.alt.trim().toLowerCase().includes(variantName.toLowerCase());
      thumb.style.display = matches ? '' : 'none';
      thumb.style.opacity = matches ? '1' : '0';
      thumb.classList.remove('is-active');
    });
    if (firstVisible) {
      setActiveSlide(gallery, firstVisible);
    } else {
      showAllImages();
    }
    setGalleryReady(gallery);
  }
  function init() {
    var variantName = null;
    var swatch = document.querySelector('input.swatch-input__input:checked');
    if (swatch) {
      variantName = swatch.value.trim();
    }
    var select = document.querySelector('form[action*="/cart/add"] select[name="id"]');
    if (!variantName && select && select.selectedOptions.length) {
      variantName = select.selectedOptions[0].text.trim();
    }
    if (!variantName || variantName.toLowerCase() === 'default title') {
      showAllImages();
      return;
    }
    filterVariant(variantName);
  }
  document.body.addEventListener('click', function (event) {
    var swatch = event.target.closest('input.swatch-input__input');
    if (swatch) {
      filterVariant(swatch.value.trim());
      return;
    }
    var thumb = event.target.closest('.thumbnail-list__item');
    if (thumb && thumb.dataset.target) {
      event.preventDefault();
      setActiveSlide(getGallery(), thumb.dataset.target);
    }
  });
  init();
});

/***/ }),

/***/ "./resources/style.scss":
/*!******************************!*\
  !*** ./resources/style.scss ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/scripts": 0,
/******/ 			"assets/style": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunksar_wp_theme"] = self["webpackChunksar_wp_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/style"], () => (__webpack_require__("./resources/scripts.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/style"], () => (__webpack_require__("./resources/style.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;